<template>
  <el-row class="container">
    <el-col :offset="4" :span="16">
      <logo :title="title" :primary-color="primaryColor"></logo>
      {{welcomeBody}}
      <br><br>
      <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" style="margin: auto; width:90%;">
        <tr>
          <td style="text-align: center;">
            <a :href="appleStore"><img src="/src/assets/img/appStoreBadge@2x.png" aria-hidden="true" alt="alt_text" border="0" style="width:95%; height: auto; font-family: sans-serif;"></a>
          </td>
          <td style="text-align: center;">
            <a :href="googlePlay"><img src="/src/assets/img/googlePlayBadge@2x.png" aria-hidden="true" alt="alt_text" border="0" style="width:95%; height: auto; font-family: sans-serif;"></a>
          </td>
        </tr>
      </table>
      <table v-if="isMobile" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" style="margin: auto; width:90%;">
        <tr>
          <td :style="{background: primaryColor}" style="border-radius: 30px; text-align: center;" class="button-td">
            <a :href="url" :style="{background: primaryColor, 'border-color': primaryColor}" style="border: 15px solid; font-family: 'Nunito Sans', sans-serif; font-size: 17px; font-weight: 700; line-height: 1.1; text-align: center; text-decoration: none; display: block; border-radius: 30px;" class="button-a">
              <span style="color:#ffffff;" class="button-link">&nbsp;&nbsp;&nbsp;&nbsp;Open App&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </a>
          </td>
        </tr>
      </table>
      <company :name="footer.companyName" :url="footer.companyUrl" :address="footer.companyAddress" :contact="footer.companyContact" :primary-color="primaryColor"></company>
    </el-col>
  </el-row>
</template>

<script>
  import main from './Welcome.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import '../style.scss';
  @import './Welcome.scss';
</style>



// WEBPACK FOOTER //
// Welcome.vue?65cc4a7f